import { render, staticRenderFns } from "./CheckboxgroupField.vue?vue&type=template&id=2b057584&"
import script from "./CheckboxgroupField.vue?vue&type=script&lang=js&"
export * from "./CheckboxgroupField.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxgroupField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VSubheader,VTextField})
